
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[...detail]",
      function () {
        return require("private-next-pages/courses/[...detail].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/[...detail]"])
      });
    }
  